import React, { useEffect, useState } from 'react';
import MostrarPuntaje from '../componentes/MostrarPuntaje';
import io from 'socket.io-client';
import { socket } from '../socket';

const Salto = () => {
    const [nombre, setNombre] = useState('');
    const [club, setClub] = useState('');
    const [scoreType, setscoreType] = useState('');
    const [dificultad, setDificultad] = useState('');
    const [ejecucion, setEjecucion] = useState('');

    useEffect(() => {
        socket.on('saltodata', data => {
            setNombre(data.nombre);
            setClub(data.club);
            setscoreType(data.scoreType);
            setDificultad(data.dificultad);
            setEjecucion(data.ejecucion); 
        });
    }, []);
    
    return (
        <div>
            <MostrarPuntaje aparato={"salto"} nombre={nombre} club={club} ejecucion={ejecucion} dificultad={dificultad} scoreType={scoreType}/>
        </div>
    );
};

export default Salto;
